module.exports = __webpack_public_path__ + "img/Plus Bank .de2fc5e1.png";